import React from 'react';
import { useState } from 'react';

export default function NewsletterForm({ label, btnText, btnArrowUrl }) {
  const [result, setResult] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);
    formData.append("access_key", "acb2b372-2bae-44ba-be89-2bdd6f2baab7");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      setResult("Error");
    }
  };


  return (
    <>
      {label && <p>Your Email</p>}
      <form onSubmit={handleSubmit} className="cs_newsletter_form">
        <input
          type="text"
          className="cs_form_field"
          placeholder="example@email.com"
          name="email"
          style={{ color: '#747070ff' }}
        />
        <button className="cs_btn cs_style_1">
          <span>{btnText}</span>
          <i>
            <img src={btnArrowUrl} alt="Icon" />
            <img src={btnArrowUrl} alt="Icon" />
          </i>
        </button>
      </form>
      <span style={{ color: 'white', fontSize: '24px', fontWeight: 'bold', paddingTop: '20px' }}>{result}</span>
    </>
  );
}
